import { render, staticRenderFns } from "./ProductOverallRejectPanel.vue?vue&type=template&id=2488ed39&scoped=true&"
import script from "./ProductOverallRejectPanel.vue?vue&type=script&lang=js&"
export * from "./ProductOverallRejectPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProductOverallRejectPanel.vue?vue&type=style&index=0&id=2488ed39&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2488ed39",
  null
  
)

export default component.exports